import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Wrapper = styled.div`
  background-color: ${props => props.theme.palette.general.soft};
  padding: 80px 0;
  margin: 0 10px;

  h3 {
    font-weight: 500;
    text-align: center;
  }

  .outlined {
    color: ${props => props.theme.palette.primary.alphaDark};
    font: ${font('default', 'medium', '16px/1')};
    border-color: ${props => props.theme.palette.general.light};
    transition: background 300ms ease, opacity 300ms ease;
    margin: auto;

    &:hover {
      background-color: ${props => props.theme.palette.primary.alphaDark};
      border-color: ${props => props.theme.palette.primary.alphaDark};
      color: ${props => props.theme.palette.general.light};
    }
  }
`
